/**
 * Saranyu Insta Player
 * Player Version: 4.5.0
 * Base Version: 4.0.0
 */

//  var baseUrl = 'http://164.52.216.90:8080/ratri/player';
 var baseUrl = './player';


var spjquery, spcore, splogger, Player;
isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
function SaranyuInstaPlayer(e, n, a) { sL(e, n, a) }
function cT(e) {
	return "" == e.file[0].content_url ? (mediaType = "hls", "hls") : -1 != e.file[0].content_url.indexOf("mpd") ? (mediaType = "mpd", "mpd") : -1 != e.file[0].content_url.indexOf("m3u8") ? (mediaType = "hls", "hls") : (mediaType = "mp4", "mp4")
}

function cL(e, n) {
	// var npaw = document.createElement("script"); npaw.type = "text/javascript", npaw.src = npawSDK, document.getElementsByTagName('head')[0].appendChild(npaw);
	// npaw.addEventListener("load", function () {
		gP(e, n);
	// });
}

function sL(e, n, a) {
	var container = n, object = a, mediaType = e;
	sphlsdash = "hls" == e ? `${baseUrl}/player/plugin/core/hls.latest.min.js` : `${baseUrl}/player/plugin/core/dash.all.min.js`;
	// npawSDK = "hls" == e ? `https://smartplugin.youbora.com/v6/js/adapters/hlsjs/6.7.0/sp.min.js` : `https://smartplugin.youbora.com/v6/js/adapters/dashjs/6.7.1/sp.min.js`;
	splogger = `${baseUrl}/player/external/logger/logger.min.js`;
    spcore = `${baseUrl}/player/plugin/spcore.js`;
	spui = 	 `${baseUrl}/player/ui/sp-ui.css`;
	var h = document.createElement("link"); h.rel = "stylesheet", h.type = "text/css", h.href = spui; document.getElementsByTagName('head')[0].appendChild(h);
	var s = document.createElement("script"); s.type = "text/javascript", s.src = sphlsdash, document.body.appendChild(s);
	s.addEventListener("load", function () { cL(n, a) });
}

function gP(e, n) {
	var l = document.createElement("script"); l.type = "text/javascript", l.src = splogger, document.body.appendChild(l);
	var a = document.createElement("script"); a.type = "text/javascript", a.src = spcore;
	l.addEventListener("load", function () { document.body.appendChild(a) });
	a.addEventListener("load", function () {
		Player = new SaranyuInstaPlayer.MediaPlayer(e, n, cT(n));
		try {
			window.InstaPlayer = Player;
			console.log("Spinit loaded!!!");
			n.registerCallBacks();
		}
		catch (e) {
			SaranyuInstaPlayer.Utils.DLOG.INFO(e);
		}
	});
}